module.exports = __webpack_public_path__ + "img/icon-warning-rain-red.90823918.svg";